define('responsive-gameday-game-switch-mediator/responsive-gameday-game-switch-mediator',['require','./src/js/GameSwitchMediator'],function(require) {
    return require('./src/js/GameSwitchMediator');
});
